<!-- Error Modal -->
<div
  style="overflow-y: auto"
  mdbModal
  id="errorModal"
  #errorModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
  (close)="showHideModal(false)"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header alert-danger">
        <button type="button" class="close pull-right" aria-label="Close" (click)="showHideModal(false)">
          <span aria-hidden="true">×</span>
        </button>
        <h3 class="text-center font-weight-bold">
          {{ title }}
        </h3>
      </div>
      <div class="modal-body">
        <div class="col-12 text-center">
          <div *ngIf="busy" class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <!-- HTTP Error Details -->
        <div id="httpErrorCard" class="card" *ngIf="showHttpErrorCard">
          <div class="card-body">
            <h4 class="card-title text-center">HTTP Error:</h4>
            <div class="card-text">
              <h5 *ngIf="httpStatus">Http Status Code: {{ httpStatus }}</h5>
              <span *ngIf="httpMessage">
                <h5>Message:</h5>
                <p *ngIf="httpMessage">{{ httpMessage }}</p>
              </span>
              <span *ngIf="httpDetails">
                <h5>Details:</h5>
                <p *ngIf="httpDetails">{{ httpDetails }}</p>
              </span>
            </div>
          </div>
        </div>
        <!-- End HTTP Error Details -->

        <!-- API Error Details -->
        <div id="apiErrorCard" class="card" *ngIf="showApiErrorCard">
          <div class="card-body">
            <h4 class="card-title text-center">API Error:</h4>
            <div class="card-text">
              <h5 *ngIf="apiCode">API Code: {{ apiCode }}</h5>
              <h5 *ngIf="apiStatusCode">Status: {{ apiStatusCode }}</h5>
              <span *ngIf="apiMessage">
                <h5>Message:</h5>
                <p>{{ apiMessage }}</p></span
              >
              <span *ngIf="apiDetails"
                ><h5>Details:</h5>
                <p>{{ apiDetails }}</p>
              </span>
            </div>
          </div>
        </div>
        <!-- End API Error Details -->

        <div id="endpointUrl" class="card-body">
          <span *ngIf="url">
            <h5>Endpoint Url:</h5>
            <p class="card-text">{{ url }}</p>
          </span>
        </div>

        <div class="modal-footer justify-content-right">
          <button type="button" mdbBtn color="trakly" class="relative waves-light" (click)="showHideModal(false)">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
